let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("il1NS")).then(() => parcelRequire('guBtq'));